// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__2XPpI","toolbar":"Dashboard_toolbar__3QVWR","drawer":"Dashboard_drawer__3BwL-","content":"Dashboard_content__2Ctdt"};